document.addEventListener("DOMContentLoaded", () => {
  // Функция для изменения текста кнопки
  function updateButtonText(buttonId, text, disabled) {
    const button = document.getElementById(buttonId);
    if (button) {
      const spanText = button.querySelector(".single-add-to-cart-button--text");
      if (spanText && spanText.textContent.trim() !== text) {
        spanText.textContent = text;
      }
      button.disabled = disabled;
    }
  }

  function updateButtons() {
    const inventoryData = [];
    // Считываем данные из скрытого блока inventory-section
    document
      .querySelectorAll("#inventory-section .name-of-item")
      .forEach((item) => {
        const name = item.querySelector(".variant-name").textContent.trim();
        const inventory = parseInt(
          item.querySelector(".variant-inventory").textContent.trim(),
          10
        );
        const preorderButton = parseInt(
          item.querySelector(".variant-pre-order-button").textContent.trim(),
          10
        );
        const preorderButtonText = item
          .querySelector(".variant-pre-order-button-text")
          ?.textContent.trim();
        inventoryData.push({
          name,
          inventory,
          preorderButton,
          preorderButtonText,
        });
      });

    const selectedVariant = document.querySelector(".form__label__value");

    if (selectedVariant) {
      const variantText = selectedVariant.textContent.trim();

      // Проверяем, что товар подходит под условия

      // Ищем текущий вариант в данных инвентаря
      const variantInfo = inventoryData.find(
        (variant) => variant.name.toLowerCase() === variantText.toLowerCase()
      );

      if (!variantInfo) {
        return;
      }

      const isOutOfStock = variantInfo.inventory < 1;

      // Логика изменения текста кнопки в зависимости от наличия товара
      if (isOutOfStock) {
        updateButtonText("AddToCart", "SOLD OUT", true);
        updateButtonText("AddToCartSticky", "SOLD OUT", true);
        updateButtonText("AddToCartAddons", "SOLD OUT", true);
      } else if (variantInfo.preorderButton === 1) {
        if (variantInfo.preorderButtonText.length > 1) {
          updateButtonText("AddToCart", variantInfo.preorderButtonText, false);
          updateButtonText(
            "AddToCartSticky",
            variantInfo.preorderButtonText,
            false
          );
          updateButtonText(
            "AddToCartAddons",
            variantInfo.preorderButtonText,
            false
          );
        } else {
          updateButtonText("AddToCart", "PRE-ORDER NOW", false);
          updateButtonText("AddToCartSticky", "PRE-ORDER NOW", false);
          updateButtonText("AddToCartAddons", "PRE-ORDER NOW", false);
        }
      } else {
        updateButtonText("AddToCart", "ADD TO CART", false);
        updateButtonText("AddToCartSticky", "ADD TO CART", false);
        updateButtonText("AddToCartAddons", "ADD TO CART", false);
      }
    }
  }

  // Настраиваем MutationObserver для отслеживания изменений
  const targetNodeChangeButtonText = document.querySelector(
    "#Product-Drawer-Content"
  );
  const observer = new MutationObserver(() => {
    updateButtons();
  });

  // Начинаем отслеживать изменения в содержимом карточки продукта
  if (targetNodeChangeButtonText) {
    observer.observe(targetNodeChangeButtonText, {
      childList: true,
      subtree: true,
    });
  }

  // Выполняем обновление кнопок сразу после загрузки страницы
  updateButtons();

  // Проверяем кнопки каждые 700 мс
  setInterval(() => {
    updateButtons();
  }, 700);
});
